export const COMMUNITY_INFO_TABS = {
  GENERAL: 'general',
  AMENITIES: 'amenities',
  ACTIVITIES: 'activities',
  INCENTIVES: 'incentives',
};
